import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TGetSlotsAvailabilityResponse } from '@models/slots.model';
import { IGetNearPickupStoresResponse, IGetNearStoresRequest, IGetStoreDataResponse, TGetNearStoresResponse } from '@models/store.model';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { AsHttpParams } from '@models/AsHttpParams.model';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  private URL: string = environment.rootUrl;
  private URL_LAMBDA: string = environment.lambdaUrl;

  constructor(
    private http: HttpClient
  ) { }


  public getStores(): Promise<any> {
    try {
      return this.http.get(`${this.URL}/stores?ecommerce=true`).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public async getNearPickupStores(lat: number, long: number): Promise<IGetNearPickupStoresResponse> {
    let params = new HttpParams();
    params = params.set('latitude', lat);
    params = params.set('longitude', long);
    return firstValueFrom(this.http.get<IGetNearPickupStoresResponse>(`${this.URL}/stores/for-pickup`, { params }));
  }



  public getStore(branch_id: number): Promise<IGetStoreDataResponse> {
    return firstValueFrom(this.http.get<IGetStoreDataResponse>(`${this.URL}/stores/store-name/${branch_id}`));
  }

  public getStoresByFilters(filters: any): Promise<any> {
    try {
      return this.http.get(`${this.URL}/stores?state=${filters.state ?? ''}&city=${filters.city ?? ''}&store_type=${filters.store_type ?? ''}&delivery=${filters.delivery ?? ''}&ecommerce=${filters.ecommerce ?? ''}&plaza=${filters.plaza ?? ''}`).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public getStoresByType(type: string, delivery: boolean): Promise<any> {
    return this.http.get(`${this.URL}/stores?ecommerce=true&store_type=${type}&delivery=${delivery}`).toPromise();
  }

  public getStoresByCoordsPolygon(data: IGetNearStoresRequest): Promise<TGetNearStoresResponse> {
    return lastValueFrom(this.http.post<TGetNearStoresResponse>(`${this.URL}/stores/near`, data));
  }

  public getSlotsAvailability(selected_day: string, orderId?: number): Promise<any> {
    const params: AsHttpParams = { day: selected_day };
    if (orderId) params['order_id'] = orderId.toString();
    return lastValueFrom(this.http.get<TGetSlotsAvailabilityResponse>(`${this.URL_LAMBDA}/get-slots`, { params: params ?? {} }));
  }

  public updateOrderSchedule(data: any, orderId: number): Promise<any> {
    const sendData = {
      scheduled_date: data
    };
    return lastValueFrom(this.http.patch(`${this.URL_LAMBDA}/update-slot-order?order_id=${orderId}`, sendData));
  }
}
